
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addLayout,
    getSetting,
} from "../../config/helpers";
import actions from "../../Redux/Tracking/actions";
import dynamic from "next/dynamic";
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));



const Tracking = ({trackingData}) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { statusMessage, redirect} = useSelector((state) => state.trackingReducer);
    const { template_settings} = useSelector((state) => state.globalReducer);

    const {
        template_page_settings,
    } = trackingData;

    const [trackingRef, setTrackingRef] = useState(false);
  
    // //layout setting retrieved from template settings
    // const layout = getSetting(
    //     template_settings,
    //     template_page_settings,
    //     "layout",
    //     "wide"
    // );
    
    // const layout_width =
    //     layout == "custom"
    //         ? getSetting(
    //               template_settings,
    //               template_page_settings,
    //               "custom_layout_width",
    //               "0px"
    //           )
    //         : "0px";

    useEffect(() => {
        redirect && router.push('/tracking/'+trackingRef)
    }, [redirect])
    

    const handleChange = (e) => {
        setTrackingRef(e.target.value)
    }

    const formSubmit = (e) => {
        e.preventDefault();
        if(!trackingRef || trackingRef == ''){
            dispatch ({ type: actions.TRACKING_INVALID, payload: {
                status: false,
                statusMessage: 'This field is required.'
            } })
        }
        else {
            dispatch ({ type: actions.TRACKING_GET, payload: trackingRef })
        }
    }

    const renderTrackingHeading = () => {
        return (
            <>
                <Typography component="h1" variant="h3">Track your order</Typography>
                <Typography className="mt-3">Type tracking ref. to track your delivery or collection</Typography>
            </>
        )
    }

    const renderTrackingForm = () => {
        return (
                <form className="mt-2" onSubmit={formSubmit}>
                    <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={10}>
                            <TextField
                                label="Tracking Ref."
                                name="tracking"
                                onChange={handleChange}
                                className="w-100"
                                helperText={statusMessage}
                                error={statusMessage != null ? true : false}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button type="submit" color="secondary" variant="contained">Track</Button>
                        </Grid>
                    </Grid>
                </form>
        )
    }



    const toWrapComponents = [
        renderTrackingHeading(),
        renderTrackingForm(),
    ];


    return <>
            <BoxContainer className={"mt-2"}>
                {/* {addLayout(toWrapComponents, layout, layout_width)} */}
                {renderTrackingHeading()}
                {renderTrackingForm()}
            </BoxContainer>
    </>;
}

  
export default Tracking